/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { creditRequestLogControllerAccept } from '../fn/credit-request-log/credit-request-log-controller-accept';
import { CreditRequestLogControllerAccept$Params } from '../fn/credit-request-log/credit-request-log-controller-accept';
import { creditRequestLogControllerCreate } from '../fn/credit-request-log/credit-request-log-controller-create';
import { CreditRequestLogControllerCreate$Params } from '../fn/credit-request-log/credit-request-log-controller-create';
import { creditRequestLogControllerDelete } from '../fn/credit-request-log/credit-request-log-controller-delete';
import { CreditRequestLogControllerDelete$Params } from '../fn/credit-request-log/credit-request-log-controller-delete';
import { creditRequestLogControllerFindAll } from '../fn/credit-request-log/credit-request-log-controller-find-all';
import { CreditRequestLogControllerFindAll$Params } from '../fn/credit-request-log/credit-request-log-controller-find-all';
import { creditRequestLogControllerFindById } from '../fn/credit-request-log/credit-request-log-controller-find-by-id';
import { CreditRequestLogControllerFindById$Params } from '../fn/credit-request-log/credit-request-log-controller-find-by-id';
import { creditRequestLogControllerGetPendingCount } from '../fn/credit-request-log/credit-request-log-controller-get-pending-count';
import { CreditRequestLogControllerGetPendingCount$Params } from '../fn/credit-request-log/credit-request-log-controller-get-pending-count';
import { creditRequestLogControllerReject } from '../fn/credit-request-log/credit-request-log-controller-reject';
import { CreditRequestLogControllerReject$Params } from '../fn/credit-request-log/credit-request-log-controller-reject';
import { creditRequestLogControllerSearchCursor } from '../fn/credit-request-log/credit-request-log-controller-search-cursor';
import { CreditRequestLogControllerSearchCursor$Params } from '../fn/credit-request-log/credit-request-log-controller-search-cursor';
import { creditRequestLogControllerSearchOffset } from '../fn/credit-request-log/credit-request-log-controller-search-offset';
import { CreditRequestLogControllerSearchOffset$Params } from '../fn/credit-request-log/credit-request-log-controller-search-offset';
import { creditRequestLogControllerUpdate } from '../fn/credit-request-log/credit-request-log-controller-update';
import { CreditRequestLogControllerUpdate$Params } from '../fn/credit-request-log/credit-request-log-controller-update';
import { CreditRequestLogDto } from '../models/credit-request-log-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CreditRequestLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `creditRequestLogControllerFindAll()` */
  static readonly CreditRequestLogControllerFindAllPath = '/api/creditRequestLog';

  /**
   * 크레딧 신청 로그 전체 조회.
   *
   * 크레딧 신청 로그 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditRequestLogControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerFindAll$Response(params?: CreditRequestLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CreditRequestLogDto>>> {
    return creditRequestLogControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 신청 로그 전체 조회.
   *
   * 크레딧 신청 로그 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditRequestLogControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerFindAll(params?: CreditRequestLogControllerFindAll$Params, context?: HttpContext): Observable<Array<CreditRequestLogDto>> {
    return this.creditRequestLogControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CreditRequestLogDto>>): Array<CreditRequestLogDto> => r.body)
    );
  }

  /** Path part for operation `creditRequestLogControllerCreate()` */
  static readonly CreditRequestLogControllerCreatePath = '/api/creditRequestLog';

  /**
   * 크레딧 신청 로그 생성.
   *
   * 크레딧 신청 로그을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditRequestLogControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  creditRequestLogControllerCreate$Response(params: CreditRequestLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestLogDto>> {
    return creditRequestLogControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 신청 로그 생성.
   *
   * 크레딧 신청 로그을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditRequestLogControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  creditRequestLogControllerCreate(params: CreditRequestLogControllerCreate$Params, context?: HttpContext): Observable<CreditRequestLogDto> {
    return this.creditRequestLogControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditRequestLogDto>): CreditRequestLogDto => r.body)
    );
  }

  /** Path part for operation `creditRequestLogControllerGetPendingCount()` */
  static readonly CreditRequestLogControllerGetPendingCountPath = '/api/creditRequestLog/pending-count';

  /**
   * 대기 중인 크레딧 신청 수 조회.
   *
   * 대기 중인 크레딧 신청 수를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditRequestLogControllerGetPendingCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerGetPendingCount$Response(params?: CreditRequestLogControllerGetPendingCount$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return creditRequestLogControllerGetPendingCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 대기 중인 크레딧 신청 수 조회.
   *
   * 대기 중인 크레딧 신청 수를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditRequestLogControllerGetPendingCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerGetPendingCount(params?: CreditRequestLogControllerGetPendingCount$Params, context?: HttpContext): Observable<number> {
    return this.creditRequestLogControllerGetPendingCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `creditRequestLogControllerSearchOffset()` */
  static readonly CreditRequestLogControllerSearchOffsetPath = '/api/creditRequestLog/search/offset';

  /**
   * 크레딧 신청 로그 오프셋 기반 조회.
   *
   * 크레딧 신청 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditRequestLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerSearchOffset$Response(params: CreditRequestLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return creditRequestLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 신청 로그 오프셋 기반 조회.
   *
   * 크레딧 신청 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditRequestLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerSearchOffset(params: CreditRequestLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.creditRequestLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `creditRequestLogControllerSearchCursor()` */
  static readonly CreditRequestLogControllerSearchCursorPath = '/api/creditRequestLog/search/cursor';

  /**
   * 크레딧 신청 로그 커서 기반 조회.
   *
   * 크레딧 신청 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditRequestLogControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerSearchCursor$Response(params: CreditRequestLogControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return creditRequestLogControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 신청 로그 커서 기반 조회.
   *
   * 크레딧 신청 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditRequestLogControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerSearchCursor(params: CreditRequestLogControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.creditRequestLogControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `creditRequestLogControllerFindById()` */
  static readonly CreditRequestLogControllerFindByIdPath = '/api/creditRequestLog/{id}';

  /**
   * 크레딧 신청 로그 ID 기반 조회.
   *
   * 크레딧 신청 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditRequestLogControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerFindById$Response(params: CreditRequestLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestLogDto>> {
    return creditRequestLogControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 신청 로그 ID 기반 조회.
   *
   * 크레딧 신청 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditRequestLogControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerFindById(params: CreditRequestLogControllerFindById$Params, context?: HttpContext): Observable<CreditRequestLogDto> {
    return this.creditRequestLogControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditRequestLogDto>): CreditRequestLogDto => r.body)
    );
  }

  /** Path part for operation `creditRequestLogControllerDelete()` */
  static readonly CreditRequestLogControllerDeletePath = '/api/creditRequestLog/{id}';

  /**
   * 크레딧 신청 로그 삭제.
   *
   * 크레딧 신청 로그을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditRequestLogControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerDelete$Response(params: CreditRequestLogControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestLogDto>> {
    return creditRequestLogControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 신청 로그 삭제.
   *
   * 크레딧 신청 로그을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditRequestLogControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerDelete(params: CreditRequestLogControllerDelete$Params, context?: HttpContext): Observable<CreditRequestLogDto> {
    return this.creditRequestLogControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditRequestLogDto>): CreditRequestLogDto => r.body)
    );
  }

  /** Path part for operation `creditRequestLogControllerUpdate()` */
  static readonly CreditRequestLogControllerUpdatePath = '/api/creditRequestLog/{id}';

  /**
   * 크레딧 신청 로그 수정.
   *
   * 크레딧 신청 로그을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditRequestLogControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  creditRequestLogControllerUpdate$Response(params: CreditRequestLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestLogDto>> {
    return creditRequestLogControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 신청 로그 수정.
   *
   * 크레딧 신청 로그을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditRequestLogControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  creditRequestLogControllerUpdate(params: CreditRequestLogControllerUpdate$Params, context?: HttpContext): Observable<CreditRequestLogDto> {
    return this.creditRequestLogControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditRequestLogDto>): CreditRequestLogDto => r.body)
    );
  }

  /** Path part for operation `creditRequestLogControllerAccept()` */
  static readonly CreditRequestLogControllerAcceptPath = '/api/creditRequestLog/{id}/accept';

  /**
   * 크레딧 신청 로그 승인
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditRequestLogControllerAccept()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerAccept$Response(params: CreditRequestLogControllerAccept$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestLogDto>> {
    return creditRequestLogControllerAccept(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 신청 로그 승인
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditRequestLogControllerAccept$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerAccept(params: CreditRequestLogControllerAccept$Params, context?: HttpContext): Observable<CreditRequestLogDto> {
    return this.creditRequestLogControllerAccept$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditRequestLogDto>): CreditRequestLogDto => r.body)
    );
  }

  /** Path part for operation `creditRequestLogControllerReject()` */
  static readonly CreditRequestLogControllerRejectPath = '/api/creditRequestLog/{id}/reject';

  /**
   * 크레딧 신청 로그 거절
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditRequestLogControllerReject()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerReject$Response(params: CreditRequestLogControllerReject$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestLogDto>> {
    return creditRequestLogControllerReject(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 신청 로그 거절
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditRequestLogControllerReject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditRequestLogControllerReject(params: CreditRequestLogControllerReject$Params, context?: HttpContext): Observable<CreditRequestLogDto> {
    return this.creditRequestLogControllerReject$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditRequestLogDto>): CreditRequestLogDto => r.body)
    );
  }

}
